<template>
  <DetailsSkeleton v-if="!writingDetails" />
  <div v-else>
    <teleport to="body">
      <vue-easy-lightbox :visible="visible" :imgs="imgs" :index="index" @hide="handleHide"></vue-easy-lightbox>
    </teleport>
    <div class="
        grid grid-cols-2
        layout-padding
        mt-[100px]
        h-full
        work-details-container
        py-[40px]
      ">
      <div class="
          col-span-2
          lg:col-span-1
          h-max
          mt-5
          lg:mt-0 lg:min-h-[85vh]
          flex flex-col
          justify-center
          text-section
          lg:order-first
          order-last
        ">
        <div>
          <div class="text-lg font-bold">
            {{ content.artWorks }} / {{ content.writings }}
          </div>
          <div class="lg:text-4xl text-2xl mt-4 font-bold">
            {{ writingDetails?.title }}
          </div>

          <div class="mt-6 ">

            {{ writingDetails?.year }}
          </div>
          <div class="mt-4 w-10/12 text-justify" v-html="writingDetails?.description">

          </div>
        </div>
      </div>

      <img @click="showImgs(writingDetails?.image)" :src="writingDetails?.image" alt="slide" class="
          col-span-2
          lg:col-span-1 lg:order-last
          order-first
          lg:h-[85vh]
          h-[300px]
          w-full
          object-contain
        " />
    </div>

  </div>
</template>

<script>

export default {
  inject: ["content"],
  props: ["id"],
  data() {
    return {
      imgs: [],
      visible: false,
      index: 0, // default: 0,
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 40,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 60,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 80,
        },
      },

    };
  },
  computed: {
    writingDetails() {
      return this.$store.getters["archive/writing"];
    },

  },



  methods: {
    showImgs(img) {
      this.imgs = img;
      this.visible = true;
    },
    handleHide() {
      this.visible = false;
    },
  },
  mounted() {
    this.$store.dispatch("archive/getWriting", this.id);

  }

};
</script>